(function ($) {
  var imkt = window.imkt || (window.imkt = {});
  imkt.utils = imkt.utils || {};
  imkt.sourcetree = imkt.sourcetree || {};

  imkt.sourcetree.Homepage = function (domRoot, params) {

    this.$domRoot = $("body");
    this.$navbarCTA = $("#navDownloadButton", this.$domRoot);
    this.$buttonHero = $(".product-tour-hero--video__button .button", this.$domRoot);
    this.$linkHero = $(".product-tour-hero--video__link--secondary .cms-link", this.$domRoot);
    this.$buttonPrimary = $(".button--primary-download", this.$domRoot);
    this.$buttonSecondary = $(".button--secondary-download", this.$domRoot);
    this.$buttonDownloadAgain = $('.download--again', this.$domRoot);

    this.downloadButtons = [
      this.$navbarCTA,
      this.$buttonHero,
      this.$linkHero,
      this.$buttonPrimary,
      this.$buttonSecondary
    ];

    this.downloadUrlMac = this.$buttonHero.attr("href");
    this.downloadUrlWindows = this.$linkHero.attr("href");

    this.STRING_MAC = "Mac OS X";
    this.STRING_WINDOWS = "Windows";

    this.init();
  };

  imkt.sourcetree.Homepage.prototype = {
    init: function () {
      if ($('body').hasClass('edit')) {
        return;
      }

      this.bindEvents();
    },
    bindClickDownload: function ($downloadButton) {
      var self = this;

      var imkt = window.imkt || (window.imkt = {});
      imkt.common = imkt.common || {};
      imkt.common.DownloadHelper.download($("#download-view"), $downloadButton);
      
      $($downloadButton).on('click', function(event) {  
        self.trackEvent(event);
      });
    },
    bindEvents: function () {
      this.downloadButtons.forEach(this.bindClickDownload, this);
  
      this.setDefaultDataAttributes();
  
      // detect OS and swap download links if OS is Windows
      if (imkt.utils.browser.isWindows()) {
        this.swapDownloadLinks();
      }

      // download helper uses 'data-href' instead of href directly
      // so make sure all download buttons have it
      this.downloadButtons.forEach(function($btn) {
        $btn.attr('data-href', $btn.attr('href')); 
      });
    },
    trackEvent: function(event) {
      imkt.utils.tracking.trackEvent(
        'Started Download',
        this.buildTrackingData(event.currentTarget)
      );
    },
    setDefaultDataAttributes: function() {
      this.$buttonPrimary.data('platform', this.STRING_MAC);
      this.$buttonSecondary.data('platform', this.STRING_WINDOWS);
      this.$buttonHero.data('platform', this.STRING_MAC);
      this.$linkHero.data('platform', this.STRING_WINDOWS);
      this.$navbarCTA.data('platform', this.STRING_MAC);
      this.$buttonDownloadAgain.data('platform', this.STRING_MAC);
    },
    swapDownloadLinks: function () {
      // Swap href, text, and data attribute from Mac OS X to Windows
      var tempPrimaryText = this.$buttonHero.text();
      var tempSecondaryText = this.$linkHero.text();

      this.$buttonHero.attr("href", this.downloadUrlWindows).text(tempPrimaryText.replace(this.STRING_MAC, this.STRING_WINDOWS));
      this.$linkHero.attr("href", this.downloadUrlMac).text(tempSecondaryText.replace(this.STRING_WINDOWS, this.STRING_MAC));
      this.$buttonHero.data('platform', this.STRING_WINDOWS);
      this.$linkHero.data('platform', this.STRING_MAC);

      this.$buttonPrimary.attr("href", this.downloadUrlWindows).text(tempPrimaryText.replace(this.STRING_MAC, this.STRING_WINDOWS));
      this.$buttonSecondary.attr("href", this.downloadUrlMac).text(tempSecondaryText.replace(this.STRING_WINDOWS, this.STRING_MAC));
      this.$buttonPrimary.data('platform', this.STRING_WINDOWS);
      this.$buttonSecondary.data('platform', this.STRING_MAC);

      this.$navbarCTA.attr("href", this.downloadUrlWindows);
      this.$navbarCTA.data('platform', this.STRING_WINDOWS);

      this.$buttonDownloadAgain.data('platform', this.STRING_WINDOWS);
    },
    // returns a file name (everthing after the last / of the url);
    getFileName: function (filePath) {
      var fileName;
      try {
        fileName = filePath.substr(filePath.lastIndexOf('/') + 1);
      } catch (error) {
        fileName = "Unknown";
      }
      return fileName;
    },
    buildTrackingData: function(button) {
      var fileUrl = $(button).attr('href').split("?")[0];
      var data = {
        productName: 'SourceTree',
        productPlatform: $(button).data('platform'),
        fileName: this.getFileName(fileUrl),
        fileUrl: fileUrl,
        optimizelyBuckets: imkt.utils.storage.getCookie('optimizelyBuckets'),
        optimizelyEndUserId: imkt.utils.storage.getCookie('optimizelyEndUserId'),
        optimizelySegments: imkt.utils.storage.getCookie('optimizelySegments'),
      };
      return data;
    }
  };

  // on document ready
  $(function () {
    var SourcetreeJs = new imkt.sourcetree.Homepage();
  });

})(jQuery);
